export const VERSION = '2.11.8';
